"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabType = void 0;
var TabType;
(function (TabType) {
    TabType[TabType["SalesBrochures"] = 0] = "SalesBrochures";
    TabType[TabType["PriceList"] = 1] = "PriceList";
    TabType[TabType["FloorPlans"] = 2] = "FloorPlans";
    TabType[TabType["SalesArrangement"] = 3] = "SalesArrangement";
    TabType[TabType["RegisterOfTransactions"] = 4] = "RegisterOfTransactions";
})(TabType = exports.TabType || (exports.TabType = {}));
